// Malware scanning contracts (owner decision PD-707; clamav stream PD-645 – PD-654). The scanner's
// operations status is MalwareScannerHealth in operations.ts; scan facts ride on the upload DTOs.
import { z } from 'zod';

/** PD-651: an explicit, audited rescan of an upload whose malware check failed or never ran. */
export const RescanRequest = z.object({ expectedVersion: z.number().int().min(1) });
export type RescanRequest = z.infer<typeof RescanRequest>;
